import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

export const conversionLogsList = (params = {}) => {
	const cleaned = {}
	for (const key in params) {
		if (params[key] !== null && params[key] !== '' && params[key] !== undefined) {
			cleaned[key] = params[key]
		}
	}
	return Http.get(`/marketing-conversion-logs${serialize(cleaned)}`)
}

export const conversionLogRetry = (id) => Http.post(`/marketing-conversion-logs/${id}/retry`)

export const conversionLogRetryAll = () => Http.post('/marketing-conversion-logs/retry-all')
